/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useStateValue } from "../../../context/store";
import {
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  Backdrop,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { styles } from "./styles";

import {
  getContractTypeById,
  getContractTypesValues,
  saveContractType,
  editContractType,
} from "../../../actions/contract-type-actions";
import { ERROR_MESSAGE, REQUIRED_MESSAGE } from "../../../constants";
import { defaultValues } from "./models";
import ModalConfirmBase from "../../../utils/form/modalConfirmBase";
import { getTipoDeContrato } from "../../../actions/dummy-actions";

const ContractTypeForm = (props) => {
  const [{}, dispatch] = useStateValue();
  const id = props.id;
  const isAddMode = id ? false : true;
  const classes = styles();
  const [contractType, setContractType] = useState([]);
  const [contractTypesValues, setContractTypesValues] = useState([]);
  const [notificationIsDisabled, setNotificationIsDisabled] = useState(true);
  const [fechaFinalIsDisabled, setFechaFinalIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    oneButtons: false,
    handleClickOut: () => {},
    handleClick: () => {},
    type: "",
    title: "",
  });

  const schema = yup.object().shape({
    contractType: yup.string().nullable().required(REQUIRED_MESSAGE),
    status: yup.string().nullable().required(REQUIRED_MESSAGE),
    headerInformation: yup.string()
    .max(2000, "Ingrese máximo 2000 caracteres")
    .nullable().required(REQUIRED_MESSAGE),
  });

  const { register, handleSubmit, setValue, control, errors } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    const getContractTypesAsync = async () => {
      const response = await getContractTypesValues(dispatch);
      setContractTypesValues(response.data);
    };
    getContractTypesAsync();
  }, []);

  useEffect(() => {
    if (!isAddMode) {
      const getContractType = async () => {
        const contractTypeResponse = await getContractTypeById(id, dispatch);
        const conType = contractTypeResponse.data;
        
        setValue("contractType", conType.contractTypes);
        if (conType.contractTypes === "CONTRATO_TERMINO_FIJO") {
          //setNotificationIsDisabled(false);
          //setValue("endDate", "No");
        } else {
          //setNotificationIsDisabled(true);
          //setValue("notification", "No");
        }
        setValue("status", conType.status);
        setValue("headerInformation", conType.headerInformation);
        
        setContractType(conType);
      };
      setTimeout(function () {
        getContractType();
      }, 100);
    }
  }, []);

  const onChangeTipoContrato = (e) => {
    e.preventDefault();
    const { value } = e.target;
    if (value === "CONTRATO_TERMINO_FIJO") {
      setNotificationIsDisabled(false);
      //setValue("endDate", "No");
    } else {
      setNotificationIsDisabled(true);
      //setValue("notification", "No");
    }
    if (value === "CONTRATO_TERMINO_INDEFINIDO") {
      setFechaFinalIsDisabled(true);
      //setValue("endDate", "No");
    } else {
      setFechaFinalIsDisabled(false);
    }
  };

  const closeMessage = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
    dispatch({
      type: "SET_CONTRACT_TYPE_FILTER",
      filter: {
        contractType: null,
        status: null,
      },
      isFilter: true,
    });
    props.toggleForm();
  };

  const closeMessageError = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const onSubmit = (data) => {
    setConfirm(() => ({
      open: true,
      question: `¿Está seguro que desea ${
        isAddMode ? "crear" : "editar"
      } el registro?`,
      type: "QUESTION",
      handleClick: () => onSubmitFinalize(data),
      handleClickOut: closeModal,
    }));
  };

  const onSubmitFinalize = async (data) => {
    setIsLoading(true);
    closeModal();
    let saveResponse;
    if (isAddMode) {
      saveResponse = await saveContractType(data, dispatch);
    } else {
      data = { ...data, id };
      saveResponse = await editContractType(data, dispatch);
    }

    if (
      saveResponse &&
      saveResponse.status >= 200 &&
      saveResponse.status < 399
    ) {
      setIsLoading(false);
      setConfirm(() => ({
        open: true,
        question: `Registro ${isAddMode ? "creado" : "editado"} exitosamente`,
        type: "SUCCESS",
        handleClick: closeMessage,
        oneButtons: true,
      }));
    } else {
      setIsLoading(false);
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: saveResponse?.data?.detail
            ? saveResponse?.data?.detail
            : ERROR_MESSAGE,
        },
      });
      closeMessageError();
      props.toggleForm();
    }
  };

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const cancelConfirm = () => {
    setConfirm(() => ({
      open: true,
      question: `¿Está seguro que NO desea continuar ${
        isAddMode ? "creando" : "editando"
      } el registro?`,
      handleClick: cancel,
      handleClickOut: closeModal,
      type: "QUESTION",
    }));
  };

  const cancel = () => {
    closeModal();
    if (isAddMode) {
      props.toggleCreateForm();
    } else {
      props.toggleForm();
    }
  };

  //const openModal = () => setOpen(true);
  const color = isAddMode ? "#BCE5EE" : "#EEFBFF";
  const colorBackground = isAddMode ? "white" : "transparent";

  return (
    <React.Fragment>
      <ModalConfirmBase
        description={confirm.question}
        open={confirm.open}
        handleClick={confirm.handleClick}
        handleClickOut={confirm.handleClickOut}
        type={confirm.type}
        oneButtons={confirm.oneButtons}
        title={confirm.title}
      />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={classes.form}
        style={{ background: color }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("contractType") &&
                errors["contractType"].message
              }
            >
              <InputLabel htmlFor="outlined-select-contractType" shrink={true}>
                Nombre del tipo de contrato *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                notched={true}
                size="small"
                name="contractType"
                render={(props) => (
                  <Select
                    disabled={!isAddMode}
                    className={classes.dropdown}
                    label="Nombre del tipo de contrato *"
                    notched={true}
                    inputProps={{
                      name: "contractType",
                      id: "outlined-select-contractType",
                    }}
                    onChange={(e) => {
                      props.onChange(e);
                      onChangeTipoContrato(e);
                    }}
                    value={props.value}
                  >
                    {getTipoDeContrato().map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.key}
                        value={op.key}
                      >
                        {op.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <FormHelperText>
                {errors.hasOwnProperty("contractType") &&
                  errors["contractType"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("status") && errors["status"].message
              }
            >
              <InputLabel htmlFor="outlined-select-status" shrink={true}>
                Estado *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.dropdown}
                label="Estado *"
                size="small"
                name="status"
                notched={true}
                inputProps={{
                  name: "status",
                  id: "outlined-select-status",
                }}
                as={
                  <Select>
                    <MenuItem className={classes.menuItem} value="Activo">
                      Activo
                    </MenuItem>
                    <MenuItem className={classes.menuItem} value="Inactivo">
                      Inactivo
                    </MenuItem>
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("status") && errors["status"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={12} lg={12}>
          <FormControl fullWidth>
            <TextField
              fullWidth
              variant="outlined"
              inputRef={register}
              className={classes.notes}
              label="Pre Clausulas *"
              name="headerInformation"
              placeholder="Observación"
              multiline
              rows={3}
              rowsMax={3}
              InputLabelProps={{ shrink: true }}
              error={
                !!errors.hasOwnProperty("headerInformation") &&
                errors["headerInformation"].message
              }
            />
            <FormHelperText style={{ color: "#f44336" }}>
              {errors.hasOwnProperty("headerInformation") &&
                errors["headerInformation"].message}
            </FormHelperText>
          </FormControl>
        </Grid>
          
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            justify="flex-end"
            style={{ marginTop: "0px", paddingRight: "12px" ,textAlign: "right"}}
          >
            <Button
              variant="contained"
              className={classes.buttonCancel}
              style={{ background: colorBackground }}
              onClick={cancelConfirm}
            >
              CANCELAR
            </Button>
            &nbsp;&nbsp;
            <Button
              variant="contained"
              className={classes.buttonSearch}
              type="submit"
              disabled={isLoading}
            >
              {isAddMode ? "GUARDAR" : "EDITAR"}
            </Button>
          </Grid>
        </Grid>
      </form>
      <Backdrop
        //className={classes.backdrop}
        style={{ zIndex: "9999" }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default ContractTypeForm;
